import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/crystaSureLogo.svg'
import _imports_1 from '@/assets/pass.png'
import _imports_2 from '@/assets/fail.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3bb20a14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "navbar bg-white p-2 sticky z-50 top-0 left-0 flex shadow"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"navbar-start\" data-v-3bb20a14><div class=\"w-40\" data-v-3bb20a14><div class=\"lg:flex\" data-v-3bb20a14><span class=\"text-lg font-bold cursor-pointer\" data-v-3bb20a14><img src=\"" + _imports_0 + "\" alt=\"\" class=\"crystallineLogo h-8\" data-v-3bb20a14></span></div></div></div>", 1)
const _hoisted_3 = { class: "navbar-center" }
const _hoisted_4 = { class: "items-center justify-center lg:flex" }
const _hoisted_5 = { class: "navbar-end" }
const _hoisted_6 = { class: "h-screen overflow-scroll" }
const _hoisted_7 = { class: "flex items-center flex-col p-3" }
const _hoisted_8 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_10 = { class: "maincontainer flex flex-col items-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"startSection p-4\" data-v-3bb20a14><h3 class=\"font-semibold\" data-v-3bb20a14>Read the question and answer carefully.</h3><div class=\"startpoints py-6 px-8\" data-v-3bb20a14><ul class=\"list-disc\" data-v-3bb20a14><li class=\"text-base\" data-v-3bb20a14>Total number of questions are 20 and all questions are mandatory.</li><li class=\"text-base\" data-v-3bb20a14>You should acheive 80% to pass the test.</li><li class=\"text-base\" data-v-3bb20a14>The course will not be completed without a pass result.</li><li class=\"text-base\" data-v-3bb20a14>Make sure that you clicked on submit button to successfully complete the test.</li><li class=\"text-base\" data-v-3bb20a14>Try to submit the answers in 30 minutes.</li></ul></div></div>", 1)
const _hoisted_13 = { class: "absolute bottom-5 right-5 startButton" }
const _hoisted_14 = { class: "flex flex-row-reverse mt-2 cursor-pointer" }
const _hoisted_15 = {
  key: 1,
  class: "questions"
}
const _hoisted_16 = { class: "questionblock" }
const _hoisted_17 = { class: "titleheader text-sm font-semibold mt-2" }
const _hoisted_18 = { class: "optionsblock" }
const _hoisted_19 = ["value", "id", "onChange"]
const _hoisted_20 = ["value", "id", "onChange"]
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "absolute bottom-5 right-5" }
const _hoisted_23 = { class: "flex flex-row-reverse mt-2 cursor-pointer" }
const _hoisted_24 = {
  key: 2,
  class: "scorecard flex justify-center items-center flex-col"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "h-16"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-green text-2xl font-semibold" }, "Pass", -1))
const _hoisted_27 = { class: "mt-6 text-xl" }
const _hoisted_28 = {
  key: 3,
  class: "scorecard flex justify-center items-center flex-col"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "h-16"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-error text-2xl font-semibold" }, "Failed", -1))
const _hoisted_31 = { class: "mt-6 text-xl" }
const _hoisted_32 = {
  key: 4,
  class: "flex items-center justify-between h-screen"
}
const _hoisted_33 = { key: 5 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-40 fixed inset-0 z-50 bg-black" }, null, -1))
const _hoisted_35 = { class: "fixed inset-0 flex items-center z-index-box justify-center" }
const _hoisted_36 = { class: "border-0 rounded overflow-auto fixed flex flex-col w-full max-w-xl bg-white ratingBox" }
const _hoisted_37 = { class: "flex items-center justify-between py-4 px-2 bg-primary" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white pl-2" }, "Feedback", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.5868 3.60317C3.23149 3.79159 3.03768 4.10383 3.01077 4.52375C2.97308 5.14285 2.93001 5.08901 5.09417 7.26394L7.05915 9.23968L5.14263 11.167C3.08075 13.2288 3 13.3257 3 13.8426C3 14.494 3.51143 15 4.16822 15C4.67426 14.9946 4.78193 14.9085 6.83842 12.8574L8.76033 10.9355L10.6876 12.8574C11.7428 13.9125 12.6957 14.817 12.7979 14.8708C12.9218 14.9354 13.1048 14.9677 13.3363 14.9731C14.0308 14.9731 14.4937 14.5101 14.4937 13.8156C14.4883 13.5841 14.456 13.4011 14.3914 13.2773C14.3376 13.175 13.4332 12.2221 12.378 11.167L10.4615 9.23968L12.4265 7.26394C14.5906 5.08901 14.5476 5.14285 14.5099 4.52375C14.483 4.10383 14.2892 3.79159 13.9339 3.60317C13.6485 3.45243 13.1694 3.43628 12.8625 3.56549C12.728 3.61932 12.0173 4.29226 10.7145 5.59506L8.76033 7.5385L6.80612 5.59506C5.50332 4.29226 4.7927 3.61932 4.65811 3.56549C4.35125 3.43628 3.87212 3.45243 3.5868 3.60317Z",
    fill: "white"
  })
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ml-3 mt-3 text-xs" }, "How would you rate your experience ?", -1))
const _hoisted_43 = { class: "mt-3 ml-3 feedBack flex" }
const _hoisted_44 = ["onClick", "onMouseover"]
const _hoisted_45 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_46 = ["fill"]
const _hoisted_47 = {
  key: 0,
  class: "reviewName mt-2"
}
const _hoisted_48 = {
  key: 1,
  class: "reviewName h-6"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ml-3 feedBack mt-2 text-xs" }, "How can we improve ?", -1))
const _hoisted_50 = { class: "flex justify-center mt-3 mb-2" }
const _hoisted_51 = {
  key: 0,
  class: "flex justify-end screens"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.singleCourse.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.singleCourse[0].courseName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btnprimary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExit()))
            }, "EXIT")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.showText)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_8, "Test"))
          : (_openBlock(), _createElementBlock("h1", _hoisted_9, "Test Results"))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: _normalizeClass(["card p-8 relative font-opensans", { 'flex items-center justify-center': _ctx.scorecard && !_ctx.hideQuestions }])
          }, [
            (!_ctx.hideQuestions && !_ctx.scorecard)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNext())),
                        class: "btnprimary"
                      }, "Start")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hideQuestions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, "Q" + _toDisplayString(_ctx.counter + 1) + ". " + _toDisplayString(_ctx.question.question), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.options, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "inputGroup cursor-pointer mt-3 rounded-md font-normal flex justify-center items-center text-base",
                        key: index
                      }, [
                        (_ctx.question.questionaireType == 'RadioQuestionType')
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "radio",
                              value: option.text,
                              id: option.text,
                              onChange: ($event: any) => (_ctx.checkedoptions(index, _ctx.question, $event)),
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.question.picked) = $event)),
                              class: "cursor-pointer radio"
                            }, null, 40, _hoisted_19)), [
                              [_vModelRadio, _ctx.question.picked]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              type: "checkbox",
                              value: option.text,
                              id: option.text,
                              onChange: ($event: any) => (_ctx.checkedoptions(index, _ctx.question, $event)),
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.question.checked) = $event)),
                              class: "cursor-pointer checkbox"
                            }, null, 40, _hoisted_20)), [
                              [_vModelCheckbox, _ctx.question.checked]
                            ]),
                        _createElementVNode("label", {
                          for: option.text,
                          class: "question text-sm ml-2 w-full text-left"
                        }, _toDisplayString(option.text), 9, _hoisted_21)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        (_ctx.totalQuestions.length - 1 != _ctx.counter)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btnprimary",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onNext()))
                            }, "Next"))
                          : _createCommentVNode("", true),
                        (_ctx.totalQuestions.length - 1 == _ctx.counter)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btnprimary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSubmit()))
                            }, "Submit"))
                          : _createCommentVNode("", true),
                        (_ctx.counter != 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btnprimary mr-2",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onPrevious()))
                            }, "Previous"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.scorecard && !_ctx.hideQuestions && !_ctx.error && _ctx.showIcon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("p", _hoisted_27, "Total Score :" + _toDisplayString(_ctx.testResult.pass) + "/" + _toDisplayString(_ctx.testResult.total), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.scorecard && !_ctx.hideQuestions && !_ctx.showIcon && _ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _createElementVNode("p", _hoisted_31, "Total Score :" + _toDisplayString(_ctx.testResult.pass) + "/" + _toDisplayString(_ctx.testResult.total), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.scorecard)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "btnprimary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modules('modules')))
                  }, "Course Home"),
                  _createElementVNode("button", {
                    class: "btnprimary ml-8",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modules('startExam')))
                  }, "Retake Test")
                ]))
              : _createCommentVNode("", true),
            (_ctx.scorecard && _ctx.feedbackPage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("button", {
                          class: "float-right text-3xl",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => ((_ctx.feedbackPage = false)))
                        }, _hoisted_40)
                      ]),
                      _hoisted_41,
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewValues, (rating) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mr-3",
                            key: rating
                          }, [
                            _createElementVNode("div", {
                              class: "flex justify-center cursor-pointer",
                              onClick: ($event: any) => (_ctx.getRating(rating.value)),
                              onMouseover: ($event: any) => (_ctx.mouseOnStar(rating.value)),
                              onMouseleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.mouseleftOnStar && _ctx.mouseleftOnStar(...args)))
                            }, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_45, [
                                _createElementVNode("path", {
                                  d: "M16 4.58789L18.833 13.3069H28L20.584 18.6939L23.416 27.4129L16 22.0229L8.583 27.4119L11.416 18.6929L4 13.3069H13.167L16 4.58789Z",
                                  fill: (rating.value <= _ctx.currentRatingValue) || (rating.value <= _ctx.clickedRatingValue) ? '#1976d2' : '#E9E9E9'
                                }, null, 8, _hoisted_46)
                              ]))
                            ], 40, _hoisted_44),
                            ((rating.value == _ctx.currentRatingValue) || (rating.value == _ctx.clickedRatingValue))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(rating.name), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_48))
                          ]))
                        }), 128))
                      ]),
                      _hoisted_49,
                      _withDirectives(_createElementVNode("textarea", {
                        placeholder: "Tell us more....",
                        class: "inputboxstyling mt-2 ml-3 textbox",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.review.comments) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.review.comments]
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("button", {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitRating(_ctx.review))),
                          class: _normalizeClass(_ctx.review.rating == ''?'btndisabled pointer-events-none':'btnprimary')
                        }, "Submit", 2)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.hideQuestions && _ctx.totalQuestions.length!=0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_51, "Question " + _toDisplayString(_ctx.counter+1) + " of " + _toDisplayString(_ctx.totalQuestions.length), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}